import AWS from 'aws-sdk';

AWS.config.update({ region: 'eu-west-1' }); // Make sure this matches your region

class TokenService {
  constructor() {
    this.cognito = new AWS.CognitoIdentityServiceProvider();
    this.clientId = '4245qg8nfr209bakgtj7vogai4';
  }

  getAccessToken() {
    return localStorage.getItem('accessToken');
  }

  getIdToken() {
    return localStorage.getItem('idToken');
  }

  getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  isLoggedIn() {
    return !!this.getAccessToken() && !!this.getIdToken();
  }

  isTokenExpired() {
    const tokenExpiration = localStorage.getItem('tokenExpiration');
    if (!tokenExpiration) return true;

    return Date.now() > parseInt(tokenExpiration);
  }

  isTokenExpiringSoon(timeInMinutes = 5) {
    const tokenExpiration = localStorage.getItem('tokenExpiration');
    if (!tokenExpiration) return true;

    const timeBuffer = timeInMinutes * 60 * 1000;
    return Date.now() > parseInt(tokenExpiration) - timeBuffer;
  }

  async refreshToken() {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      return false;
    }

    const params = {
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      ClientId: this.clientId,
      AuthParameters: {
        REFRESH_TOKEN: refreshToken
      }
    };

    try {
      const data = await this.cognito.initiateAuth(params).promise();

      // Store the new tokens
      localStorage.setItem('accessToken', data.AuthenticationResult.AccessToken);
      localStorage.setItem('idToken', data.AuthenticationResult.IdToken);

      // Decode the JWT to get expiration time
      const payload = JSON.parse(atob(data.AuthenticationResult.IdToken.split('.')[1]));
      const expirationTime = payload.exp * 1000; // Convert to milliseconds
      localStorage.setItem('tokenExpiration', expirationTime.toString());

      return true;
    } catch (err) {
      console.error('Error refreshing token:', err);
      this.logout();
      return false;
    }
  }

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpiration');
    window.location.href = '/'; // Redirect to home page
  }

  async validateToken() {
    if (!this.isLoggedIn()) {
      return false;
    }

    if (this.isTokenExpiringSoon()) {
      return await this.refreshToken();
    }

    return true;
  }

  decodeToken() {
    const idToken = this.getIdToken();
    if (!idToken) return null;

    try {
      const payload = JSON.parse(atob(idToken.split('.')[1]));
      return payload;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  // Add this method to your TokenService class
  getAuthHeader() {
    const token = this.getIdToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  // Validate if a user is authenticated and has valid token
  async ensureAuthenticated() {
    const isValid = await this.validateToken();
    if (!isValid) {
      // Redirect to login
      window.location.href = '/sign-in';
      return false;
    }
    return true;
  }
}

export const tokenService = new TokenService();
export default tokenService;
